<template>
  <donut-chart-card
    title="종사자 현황"
    :value="data"
    unit="명"
    :isMoveWrite="isMoveWrite"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart02',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'company' | 'project',
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 2,
      data: [{label: '데이터 없음', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      let type = 'project';
      if (this.projectId) {
        type = 'company';
      }

      const result = await this.$store.dispatch('summary/LOAD_DONUT_EMPLOYEE', {
        type,
        projectId: this.projectId,
      });

      if (Object.keys(result).length > 0) {
        const _data = [];
        for (const key of Object.keys(result)) {
          _data.push({
            label: key,
            value: result[key],
          });
        }
        this.data = _data;
      }
    },

    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
